import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appSelectors, uiActions, portfoliosSelectors} from '@/store'
import type {Language} from '@/types'
import {mergeAll} from 'ramda'
import './info-panel.css'
import ExpandCollapse from './expand-collapse-panel'

type Props = {
  confirm: Object,
  l: Language,
  resetConfirmMessage: () => void,
}

const getNameById = (portfolios) => (id) => {
  let name = ''
  portfolios.forEach((portfolio) => {
    if (portfolio.portfolioId === Number(id)) {
      name = portfolio.name
    }
  })
  return name
}

const getDisplayedSafeNumberWithPortfolio = (safeNumberWithPortfolio, portfolios) => {
  let hyphenIndex = safeNumberWithPortfolio.indexOf('-')
  const portfolioId = safeNumberWithPortfolio.substring(0, hyphenIndex)
  const safeNumber = safeNumberWithPortfolio.substring(hyphenIndex + 1)
  const portfolioName = getNameById(portfolios)(portfolioId)
  return <span>
    <span className='align-to-left'>{safeNumber}</span>
    <span className='arrow'></span>
    <span className='align-to-right'>{portfolioName}</span>
  </span>
}

export class RawInfoPanel extends Component<Props> {
  onCloseButtonClick = () => {
    clearTimeout(this.timeout)
    this.timeout = null
    if (this.infoAlertNode) {
      this.infoAlertNode.classList.add('fadeOut')
    }
    this.props.resetConfirmMessage()
  }

  render = () => {
    let {confirm, l, portfolios} = this.props
    return confirm.message
      ? <div className={ confirm.isError
        ? 'info-alert error'
        : (confirm.stats ? 'info-alert success partly' : 'info-alert success')}
      ref={(node) => {
        this.infoAlertNode = node
      }}>
        <div className='close-button' onClick={this.onCloseButtonClick}>x</div>
        <div className='info-alert-message'>
          <span>{l(confirm.message)}</span>
          {confirm.stats
            ? (
              <div className='info-stats-ctr'>
                {confirm.stats.successfulCompanies
                  ? <h4 className='success'>
                    <span className='heading'>{l('Successful Companies')}</span>
                    <span className='count'>{confirm.stats.successfulCompanies}</span>
                  </h4>
                  : null
                }
                {confirm.stats.duplicateSafeNumbers
                  ? <ExpandCollapse heading='Duplicate Companies in Portfolio(s)' l={l}
                    count={confirm.stats.duplicateSafeNumbers.length}
                    headingClassName='duplicate'>
                    {
                      confirm.stats.duplicateSafeNumbers.map((safeNumber) =>
                        <div key={`dup-${safeNumber}`} className='list-item'>{getDisplayedSafeNumberWithPortfolio(safeNumber, portfolios)}</div>
                      )
                    }
                  </ExpandCollapse>
                  : null
                }
                {/* commenting this out as it is not required now, if you need it in future, you can use it
                {confirm.stats.failedSafeNumbers
                  ? <ExpandCollapse heading='Failed Companies' l={l}
                    count={confirm.stats.failedSafeNumbers.length}
                    headingClassName='failed'>
                    {
                      confirm.stats.failedSafeNumbers.map((safeNumber) =>
                        <div key={`fail-${safeNumber}`} className='list-item'>{getDisplayedSafeNumberWithPortfolio(safeNumber, portfolios)}</div>
                      )
                    }
                  </ExpandCollapse>
                  : null
                } */}
              </div>)
            : null}
        </div>
      </div>
      : false
  }

  componentDidUpdate = () => {
    if (this.props.confirm.message && !this.timeout) {
      this.timeout = setTimeout(this.onCloseButtonClick, this.props.confirm.stats ? 50000 : 10000)
    }
  }
}

const mapStateToProps = (state) => ({
  confirm: state.ui.confirm,
  l: appSelectors.getL(state),
  portfolios: portfoliosSelectors.getPortfolios(state),
})

export default connect(
  mapStateToProps,
  mergeAll([uiActions]),
)(RawInfoPanel)



// WEBPACK FOOTER //
// ./src/elements/info-panel.js